/**
 * Custom Hook to retrieve Google Client ID from Azure Key Vault
 * This ensures all secrets are managed centrally via Azure Functions
 */

import { useState, useEffect } from "react";
import { getCachedSecret } from "@/services/azure/secretsClient";
import { logger } from "@/utils/logger"

export const useGoogleClientId = () => {
  const [clientId, setClientId] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchClientId = async () => {
      try {
        setLoading(true);
        // Fetch Google Client ID from Azure Key Vault
        const id = await getCachedSecret("GOOGLE-CLIENT-ID");
        setClientId(id);
        setError(null);
      } catch (err: any) {
        logger.error(
          "Failed to fetch Google Client ID from Azure Key Vault:",
          err
        );
        setError(err.message || "Failed to load Google Client ID");
        setClientId("");
      } finally {
        setLoading(false);
      }
    };

    fetchClientId();
  }, []);

  return { clientId, loading, error };
};
